// extracted by mini-css-extract-plugin
export default {"conteiner":"IncomeControlPanel_conteiner__11opz","refreshButton":"IncomeControlPanel_refreshButton__PJ9Vm","label":"IncomeControlPanel_label__KOZ+m"};